import { DataService } from 'src/app/services/data.service';
import { ReviewType } from './../../../../interfaces/enums';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Review } from 'src/app/interfaces/review';
import * as _ from 'lodash';
import swal from 'sweetalert2';

@Component({
  selector: 'app-reviews',
  templateUrl: './reviews.component.html',
  styleUrls: ['./reviews.component.scss']
})
export class ReviewsComponent implements OnInit {

  reviews: Review[];

  ReviewType = ReviewType;

  currentPage = 1;
  totalItemsPerPage = 20;

  constructor(
    private toastr: ToastrService,
    private data: DataService
  ) { }

  ngOnInit() {
    this.getData();
  }

  async getData(){
    this.data.getAllReviews().subscribe((res) => {
      if(res && res.data){
        this.reviews = res.data as Review[];
      }
    })
  }

  async delete(id){
    await this.data.deleteReview(id);

    this.getData();
  }

  viewReview(id: string){
    try{
      const review = _.find(this.reviews, {_id: id}) as Review;

      swal.fire({
        title: 'Review',
        text: review.message
      })

    }catch({message}){
      this.toastr.error(message);
    }
  }
}
